'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _getOwnPropertyNames = require('babel-runtime/core-js/object/get-own-property-names');

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _analytics; // import _ from 'lodash';


exports.default = reducer;
exports.applyPromo = applyPromo;
exports.clearPayment = clearPayment;
exports.changeStep = changeStep;
exports.changePaymentMethod = changePaymentMethod;
exports.changeRequestType = changeRequestType;
exports.getCards = getCards;
exports.getPrices = getPrices;
exports.getPaymentData = getPaymentData;
exports.processPayment = processPayment;
exports.setError = setError;
exports.setPaymentRequestError = setPaymentRequestError;
exports.setErrorField = setErrorField;
exports.setField = setField;
exports.setPaymentData = setPaymentData;
exports.selectCard = selectCard;
exports.setPaypal = setPaypal;
exports.requestBooking = requestBooking;
exports.trigger = trigger;
exports.clearCreditCard = clearCreditCard;
exports.setViewedStep = setViewedStep;
exports.clickSendMessage = clickSendMessage;
exports.clickApplyPromo = clickApplyPromo;
exports.openPaypal = openPaypal;
exports.openQuickSignup = openQuickSignup;
exports.paymentOpenLoginSignup = paymentOpenLoginSignup;
exports.paymentLoggedIn = paymentLoggedIn;
exports.goToStep2 = goToStep2;
exports.goToStep3 = goToStep3;
exports.goToStep4 = goToStep4;
exports.goToMessage = goToMessage;
exports.setExtraField = setExtraField;
exports.processExtraPayment = processExtraPayment;
exports.logAcceptSwap = logAcceptSwap;
exports.logSetDate = logSetDate;
exports.logBookingError = logBookingError;
exports.enablePaymentRequest = enablePaymentRequest;
exports.disablePaymentRequest = disablePaymentRequest;
exports.logRequest = logRequest;
exports.editEmail = editEmail;
exports.logChangePaymentMethod = logChangePaymentMethod;
exports.logPaypalFail = logPaypalFail;
exports.logContinueWithoutPromo = logContinueWithoutPromo;
exports.logPayByAfterpay = logPayByAfterpay;
exports.logCreditAfterAfterpay = logCreditAfterAfterpay;
exports.logPayPalAfterAfterpay = logPayPalAfterAfterpay;
exports.checkExistingBooking = checkExistingBooking;
exports.shouldShowWarningPopup = shouldShowWarningPopup;
exports.closeWarningPopup = closeWarningPopup;
exports.submitInsurances = submitInsurances;
exports.logOnSeenInsuranceForm = logOnSeenInsuranceForm;
exports.logSubmitInsuranceFirstStep = logSubmitInsuranceFirstStep;
exports.logSubmitInsuranceLastStep = logSubmitInsuranceLastStep;
exports.logCancelInsurance = logCancelInsurance;

var _payment = require('utils/payment');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPLY_PROMO = 'redux-frontend/payment/APPLY_PROMO';
var APPLY_PROMO_SUCCESS = 'redux-frontend/payment/APPLY_PROMO_SUCCESS';
var APPLY_PROMO_FAIL = 'redux-frontend/payment/APPLY_PROMO_FAIL';

var CLEAR_PAYMENT = 'redux-frontend/payment/CLEAR_PAYMENT';
var CHANGE_STEP = 'redux-frontend/payment/CHANGE_STEP';
var CHANGE_PAYMENT_METHOD = 'redux-frontend/payment/CHANGE_PAYMENT_METHOD';
var CHANGE_REQUEST_TYPE = 'redux-frontend/payment/CHANGE_REQUEST_TYPE';

var GET_CARDS = 'redux-frontend/payment/GET_CARDS';
var GET_CARDS_SUCCESS = 'redux-frontend/payment/GET_CARDS_SUCCESS';
var GET_CARDS_FAIL = 'redux-frontend/payment/GET_CARDS_FAIL';

var GET_PAYMENT_DATA = 'redux-frontend/payment/GET_PAYMENT_DATA';
var GET_PAYMENT_DATA_SUCCESS = 'redux-frontend/payment/GET_PAYMENT_DATA_SUCCESS';
var GET_PAYMENT_DATA_FAIL = 'redux-frontend/payment/GET_PAYMENT_DATA_FAIL';

var GET_PRICES = 'redux-frontend/booking/GET_PRICES';
var GET_PRICES_SUCCESS = 'redux-frontend/booking/GET_PRICES_SUCCESS';
var GET_PRICES_FAIL = 'redux-frontend/booking/GET_PRICES_FAIL';

var PROCESS_PAYMENT = 'redux-frontend/booking/PROCESS_PAYMENT';
var PROCESS_PAYMENT_SUCCESS = 'redux-frontend/booking/PROCESS_PAYMENT_SUCCESS';
var PROCESS_PAYMENT_FAIL = 'redux-frontend/bookingId/PROCESS_PAYMENT_FAIL';

// const CHANGE_TIER = 'redux-frontend/payment/CHANGE_TIER';

var SET_PAYPAL = 'redux-frontend/payment/SET_PAYPAL';
var SET_PAYPAL_SUCCESS = 'redux-frontend/payment/SET_PAYPAL_SUCCESS';
var SET_PAYPAL_FAIL = 'redux-frontend/payment/SET_PAYPAL_FAIL';

var SELECT_CARD = 'redux-frontend/payment/SELECT_CARD';
var CLEAR_CREDIT_CARD = 'redux-frontend/payment/CLEAR_CREDIT_CARD';
var SET_ERROR = 'redux-frontend/payment/SET_ERROR';
var SET_ERROR_FIELD = 'redux-frontend/payment/SET_ERROR_FIELD';
var SET_FIELD = 'redux-frontend/payment/SET_FIELD';
var SET_PAYMENT_DATA = 'redux-frontend/payment/SET_PAYMENT_DATA';

var SET_EXTRA_FIELD = 'redux-frontend/payment/SET_EXTRA_FIELD';

var PROCESS_EXTRA_PAYMENT = 'redux-frontend/payment/PROCESS_EXTRA_PAYMENT';
var PROCESS_EXTRA_PAYMENT_SUCCESS = 'redux-frontend/payment/PROCESS_EXTRA_PAYMENT_SUCCESS';
var PROCESS_EXTRA_PAYMENT_FAIL = 'redux-frontend/payment/PROCESS_EXTRA_PAYMENT_FAIL';

var SET_VIEWED_STEP = 'redux-frontend/payment/SET_VIEWED_STEP';

var REQUEST_BOOKING = 'redux-frontend/payment/REQUEST_BOOKING';
var REQUEST_BOOKING_SUCCESS = 'redux-frontend/payment/REQUEST_BOOKING_SUCCESS';
var REQUEST_BOOKING_FAIL = 'redux-frontend/payment/REQUEST_BOOKING_FAIL';

var TRIGGER = 'redux-frontend/payment/TRIGGER';
var TRIGGER_SUCCESS = 'redux-frontend/payment/TRIGGER_SUCCESS';
var TRIGGER_FAIL = 'redux-frontend/payment/TRIGGER_FAIL';

var ENABLE_PAYMENT_REQUEST = 'redux-frontend/payment/ENABLE_PAYMENT_REQUEST';
var DISABLE_PAYMENT_REQUEST = 'redux-frontend/payment/DISABLE_PAYMENT_REQUEST';
var SET_PAYMENT_REQUEST_ERROR = 'redux-frontend/payment/SET_PAYMENT_REQUEST_ERROR';

var LOG_REQUEST = 'redux-frontend/payment/LOG_REQUEST';

var EDIT_EMAIL = 'redux-frontend/payment/EDIT_EMAIL';
var EDIT_EMAIL_SUCCESS = 'redux-frontend/payment/EDIT_EMAIL_SUCCESS';
var EDIT_EMAIL_FAIL = 'redux-frontend/payment/EDIT_EMAIL_FAIL';

var CHECK_EXISTING_BOOKING = 'redux-frontend/payment/CHECK_EXISTING_BOOKING';
var CHECK_EXISTING_BOOKING_SUCCESS = 'redux-frontend/payment/CHECK_EXISTING_BOOKING_SUCCESS';
var CHECK_EXISTING_BOOKING_FAIL = 'redux-frontend/payment/CHECK_EXISTING_BOOKING_FAIL';

var SHOULD_SHOW_WARNING_POPUP = 'redux-frontend/payment/SHOULD_SHOW_WARNING_POPUP';
var SHOULD_SHOW_WARNING_POPUP_SUCCESS = 'redux-frontend/payment/SHOULD_SHOW_WARNING_POPUP_SUCCESS';
var SHOULD_SHOW_WARNING_POPUP_FAIL = 'redux-frontend/payment/SHOULD_SHOW_WARNING_POPUP_FAIL';

var CLOSE_WARNING_POPUP = 'redux-frontend/payment/CLOSE_WARNING_POPUP';

var SUBMIT_INSURANCES = 'redux-frontend/payment/SUBMIT_INSURANCES';
var SUBMIT_INSURANCES_SUCCESS = 'redux-frontend/payment/SUBMIT_INSURANCES_SUCCESS';
var SUBMIT_INSURANCES_FAIL = 'redux-frontend/payment/SUBMIT_INSURANCES_FAIL';

var initialState = {
  requesting: false,
  requestId: null,
  viewedStep: 0,
  trip: {},
  date: null,
  cards: [],
  selectedCard: -1,
  prices: {},
  quantity: 1,
  step: 1,
  data: {},
  redeem: {},
  error: {},
  meetingPoint: '',
  paymentMethod: 'paypal',
  requestType: 'message',
  firstName: '',
  lastName: '',
  email: '',
  lastMobile: '',
  lastCountry: '',
  cardRemember: true,
  cardNumber: '',
  cardName: '',
  cardExp: '',
  cardCVV: '',
  cardType: '',
  token: '',
  promo: '',
  promoApplying: false,
  agree: false,
  letOtherJoin: false,
  bookingId: 'new',
  isHotelPickup: false,
  isBooked: false,
  isInstant: false,
  isConfirmed: false,
  makingPayment: false,
  gettingPrice: false,
  settingPaypal: false,
  dateStatus: 'ask',
  acceptSwap: false,
  extra: {
    cardNumber: '',
    cardName: '',
    cardExp: '',
    cardCVV: '',
    cardType: '',
    currency: ''
  },
  isRedeemInapplicable: false,
  paymentRequestEnabled: false,
  initializing: true,
  emailEditing: false,
  isWarningPopupShown: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case APPLY_PROMO:
      return (0, _extends5.default)({}, state, {
        promoApplying: true
      });
    case APPLY_PROMO_SUCCESS:
    case APPLY_PROMO_FAIL:
      return (0, _extends5.default)({}, state, {
        promoApplying: false
      });
    case CLEAR_PAYMENT:
      return initialState;
    case CHANGE_STEP:
      return (0, _extends5.default)({}, state, {
        step: action.step
      });
    case SET_VIEWED_STEP:
      return (0, _extends5.default)({}, state, {
        viewedStep: action.viewedStep
      });
    case CHANGE_REQUEST_TYPE:
      return (0, _extends5.default)({}, state, {
        requestType: action.requestType
      });
    case CHANGE_PAYMENT_METHOD:
      return (0, _extends5.default)({}, state, {
        paymentMethod: action.method
      });
    case GET_CARDS_SUCCESS:
      return (0, _extends5.default)({}, state, {
        cards: action.result,
        selectedCard: action.result.length > 0 && action.autoSelect ? 0 : -1
      });
    case GET_PAYMENT_DATA_SUCCESS:
      var currency = action.result.price.currency;
      var trip = action.result.trip_id;
      return (0, _extends5.default)({}, state, {
        prices: action.result.price,
        quantity: action.result.quantity,
        date: action.result.trip_date,
        trip: action.result.trip_id,
        bookingId: action.result._id,
        isConfirmed: action.result.is_confirmed,
        isBooked: action.result.is_booked,
        isCharged: action.result.is_charged,
        isInstant: action.result.is_instant,
        isCanceled: action.result.is_canceled,
        redeem: action.result.redeem || {},
        promo: action.result.redeem && action.result.redeem.code,
        isRedeemInapplicable: action.result.is_redeem_inapplicable,
        multiTierQuantity: action.result.multi_tier_quantity,
        selectedOptions: (0, _payment.genOptionsFromBooking)(trip, currency, action.result.selected_options),
        insurances: action.result.insurances || []
      });
    case GET_PRICES:
      return (0, _extends5.default)({}, state, {
        gettingPrice: true
      });
    case GET_PRICES_SUCCESS:
      return (0, _extends5.default)({}, state, {
        gettingPrice: false,
        prices: action.bookingId === 'new' ? action.result : action.result.price,
        multiTierQuantity: action.bookingId === 'new' ? state.multiTierQuantity : action.result.multi_tier_quantity
      });
    case GET_PRICES_FAIL:
      return (0, _extends5.default)({}, state, {
        gettingPrice: false
      });
    case PROCESS_PAYMENT_SUCCESS:
      return (0, _extends5.default)({}, state, {
        isBooked: true
      });
    case SELECT_CARD:
      return (0, _extends5.default)({}, state, {
        selectedCard: action.index
      });
    case CLEAR_CREDIT_CARD:
      return (0, _extends5.default)({}, state, {
        cardNumber: '',
        cardName: '',
        cardExp: '',
        cardCVV: '',
        cardType: ''
      });
    case SET_ERROR:
      return (0, _extends5.default)({}, state, {
        error: action.error
      });
    case SET_PAYMENT_REQUEST_ERROR:
      return (0, _extends5.default)({}, state, {
        paymentRequestError: action.error
      });
    case SET_ERROR_FIELD:
      return (0, _extends5.default)({}, state, {
        error: (0, _extends5.default)({}, state.error, action.error)
      });
    case SET_FIELD:
      return (0, _extends5.default)({}, state, (0, _defineProperty3.default)({}, action.name, action.value));
    case SET_PAYMENT_DATA:
      return (0, _extends5.default)({}, state, action.data);
    case SET_EXTRA_FIELD:
      return (0, _extends5.default)({}, state, {
        extra: (0, _extends5.default)({}, state.extra, (0, _defineProperty3.default)({}, action.name, action.value))
      });
    case SET_PAYPAL:
      return (0, _extends5.default)({}, state, {
        settingPaypal: true
      });
    case SET_PAYPAL_SUCCESS:
    case SET_PAYPAL_FAIL:
      return (0, _extends5.default)({}, state, {
        settingPaypal: false
      });
    case REQUEST_BOOKING:
      return (0, _extends5.default)({}, state, {
        requesting: true
      });
    case REQUEST_BOOKING_SUCCESS:
      return (0, _extends5.default)({}, state, {
        requesting: false,
        requestId: action.result.id,
        prices: action.result.prices || {}
      });
    case REQUEST_BOOKING_FAIL:
      return (0, _extends5.default)({}, state, {
        requesting: false
      });
    case ENABLE_PAYMENT_REQUEST:
      return (0, _extends5.default)({}, state, {
        paymentRequestEnabled: true
      });
    case DISABLE_PAYMENT_REQUEST:
      return (0, _extends5.default)({}, state, {
        paymentRequestEnabled: false
      });
    // case CHANGE_TIER:
    //   const multiTierQuantity = _.cloneDeep(state.multiTierQuantity);
    //   return {
    //     ...state,
    //     activeTier: action.activeTier,
    //     multiTierQuantity:
    //       multiTierQuantity.reduce((acc, curr) =>
    //         [...acc, { tier: curr.tier, sub_tiers: curr.sub_tiers.map((sub) => ({ ...sub, quantity: 0 })) }]
    //       , []),
    //     quantity: 0,
    //   };
    case EDIT_EMAIL:
      return (0, _extends5.default)({}, state, {
        emailEditing: true,
        error: (0, _extends5.default)({}, state.error, {
          editEmail: false
        })
      });
    case EDIT_EMAIL_SUCCESS:
      return (0, _extends5.default)({}, state, {
        emailEditing: false
      });
    case EDIT_EMAIL_FAIL:
      return (0, _extends5.default)({}, state, {
        emailEditing: false,
        error: (0, _extends5.default)({}, state.error, {
          editEmail: true
        })
      });
    case SHOULD_SHOW_WARNING_POPUP_SUCCESS:
      return (0, _extends5.default)({}, state, {
        isWarningPopupShown: !!action.result.is_exists
      });
    case SHOULD_SHOW_WARNING_POPUP_FAIL:
      return (0, _extends5.default)({}, state, {
        isWarningPopupShown: false
      });
    case CLOSE_WARNING_POPUP:
      return (0, _extends5.default)({}, state, {
        isWarningPopupShown: false
      });
    default:
      return state;
  }
}

function applyPromo() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var trip_id = arguments[1];
  var trip_date = arguments[2];
  var quantity = arguments[3];
  var email = arguments[4];
  var selectedOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  // eslint-disable-line
  return {
    types: [APPLY_PROMO, APPLY_PROMO_SUCCESS, APPLY_PROMO_FAIL],
    promise: function promise(client) {
      return code && code.length > 0 ? client.post('session/promo/' + code, { data: { trip_id: trip_id, trip_date: trip_date, quantity: quantity, email: email, selected_options: selectedOptions } }) : client.post('session/promo', { data: {} });
    },
    code: code
  };
}

function clearPayment() {
  return {
    type: CLEAR_PAYMENT
  };
}
function changeStep(step) {
  return {
    type: CHANGE_STEP,
    step: step
  };
}
function changePaymentMethod(method) {
  return {
    type: CHANGE_PAYMENT_METHOD,
    method: method
  };
}
function changeRequestType(requestType) {
  return {
    type: CHANGE_REQUEST_TYPE,
    requestType: requestType
  };
}
function getCards() {
  var autoSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    types: [GET_CARDS, GET_CARDS_SUCCESS, GET_CARDS_FAIL],
    promise: function promise(client) {
      return client.get('bookings/cards');
    },
    autoSelect: autoSelect
  };
}

function getPrices(trip_id, quantity, bookingId) {
  var promo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var multi_tier_quantity = arguments[4];
  var selected_options = arguments[5];
  // eslint-disable-line
  return {
    types: [GET_PRICES, GET_PRICES_SUCCESS, GET_PRICES_FAIL],
    bookingId: bookingId,
    promise: function promise(client) {
      return bookingId === 'new' ? client.post('trips/price', { data: { trip_id: trip_id, quantity: quantity, promo: promo, multi_tier_quantity: multi_tier_quantity, selected_options: selected_options } }) : client.get('/bookings/' + bookingId + '?useSession=true');
    }
  };
}
function getPaymentData(id) {
  var useSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return {
    types: [GET_PAYMENT_DATA, GET_PAYMENT_DATA_SUCCESS, GET_PAYMENT_DATA_FAIL],
    promise: function promise(client) {
      return client.get('/bookings/' + id + (useSession ? '?useSession=true' : ''));
    }
  };
}
function processPayment(id, data) {
  return {
    types: [PROCESS_PAYMENT, PROCESS_PAYMENT_SUCCESS, PROCESS_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/book', { data: data });
    }
  };
}
// export function sendMessage(id, text) {
//   return {
//     types: [SEND_MESSAGE, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAIL],
//     promise: (client) => client.post(`/bookings/${id}/messages`, {data: {text}}),
//   };
// }
function setError(error) {
  return {
    type: SET_ERROR,
    error: error
  };
}

function setPaymentRequestError(error) {
  return {
    type: SET_PAYMENT_REQUEST_ERROR,
    error: error
  };
}

function setErrorField(error) {
  return {
    type: SET_ERROR_FIELD,
    error: error
  };
}
function setField(name, value) {
  return {
    type: SET_FIELD,
    name: name,
    value: value
  };
}
function setPaymentData(data) {
  return {
    type: SET_PAYMENT_DATA,
    data: data
  };
}
function selectCard(index) {
  return {
    type: SELECT_CARD,
    index: index
  };
}
function setPaypal(id) {
  // deprecated
  return {
    types: [SET_PAYPAL, SET_PAYPAL_SUCCESS, SET_PAYPAL_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/paypal-set');
    }
  };
}

var CLICK_SEND_MESSAGE = 'redux-frontend/payment/CLICK_SEND_MESSAGE';
var CLICK_APPLY_PROMO = 'redux-frontend/payment/CLICK_APPLY_PROMO';
// const VIEW_PAYMENT_PAGE = 'redux-frontend/payment/VIEW_PAYMENT_PAGE';
var OPEN_PAYPAL = 'redux-frontend/payment/OPEN_PAYPAL'; // deprecated
var OPEN_LOGIN_SIGNUP = 'redux-frontend/payment/OPEN_LOGIN_SIGNUP';
var OPEN_QUICK_SIGNUP = 'redux-frontend/payment/OPEN_QUICK_SIGNUP';
var LOGGED_IN = 'redux-frontend/payment/LOGGED_IN';
var GO_TO_STEP2 = 'redux-frontend/payment/GO_TO_STEP2';
var GO_TO_STEP3 = 'redux-frontend/payment/GO_TO_STEP3';
var GO_TO_STEP4 = 'redux-frontend/payment/GO_TO_STEP4';
var GO_TO_MESSAGE = 'redux-frontend/payment/GO_TO_MESSAGE';
var LOG_ACCEPT_SWAP = 'redux-frontend/payment/LOG_ACCEPT_SWAP';
var LOG_SET_DATE = 'redux-frontend/payment/LOG_SET_DATE';
var LOG_BOOKING_ERROR = 'redux-frontend/payment/LOG_BOOKING_ERROR';
var LOG_SELECT_PAYMENT_METHOD = 'redux-frontend/payment/LOG_SELECT_PAYMENT_METHOD';
var LOG_PAYPAL_FAIL = 'redux-frontend/payment/LOG_PAYPAL_FAIL';
var LOG_CONTINUE_WITHOUT_PROMO = 'redux-frontend/payment/LOG_CONTINUE_WITHOUT_PROMO';
// const LOG_PAY_IN_CASH = 'redux-frontend/payment/LOG_PAY_IN_CASH';
// const LOG_CREDIT_AFTER_CASH = 'redux-frontend/payment/LOG_CREDIT_AFTER_CASH';
// const LOG_PAYPAL_AFTER_CASH = 'redux-frontend/payment/LOG_PAYPAL_AFTER_CASH';
var LOG_PAY_BY_AFTERPAY = 'redux-frontend/payment/LOG_PAY_BY_AFTERPAY';
var LOG_CREDIT_AFTER_AFTERPAY = 'redux-frontend/payment/LOG_CREDIT_AFTER_AFTERPAY';
var LOG_PAYPAL_AFTER_AFTERPAY = 'redux-frontend/payment/LOG_PAYPAL_AFTER_AFTERPAY';
var LOG_ON_SEEN_INSURANCE_FORM = 'redux-frontend/payment/LOG_ON_SEEN_INSURANCE_FORM';
var LOG_SUBMIT_INSURANCE_FIRST_STEP = 'redux-frontend/payment/LOG_SUBMIT_INSURANCE_FIRST_STEP';
var LOG_SUBMIT_INSURANCE_LAST_STEP = 'redux-frontend/payment/LOG_SUBMIT_INSURANCE_LAST_STEP';
var LOG_CANCEL_INSURANCE = 'redux-frontend/payment/LOG_CANCEL_INSURANCE';

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, REQUEST_BOOKING_SUCCESS, function (action) {
  return { name: 'Request From Trip Detail', category: 'Payment', type: action.requestType, device: action.device, requestId: action.result.id };
}), (0, _defineProperty3.default)(_analytics, CHANGE_REQUEST_TYPE, function (action, getState) {
  return { name: 'Switch Request Type', category: 'Payment', type: action.requestType, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, CLICK_SEND_MESSAGE, function (action, getState) {
  return { name: 'Click Send Message', category: 'Payment', requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, SET_VIEWED_STEP, function (action, getState) {
  return { name: 'View Payment Page', category: 'Payment', step: action.viewedStep, requestId: getState().payment.requestId, virtualPath: '/virtual/booking/' + getState().payment.requestId + '/' + action.viewedStep };
}), (0, _defineProperty3.default)(_analytics, OPEN_PAYPAL, function (action, getState) {
  return { name: 'Popup Paypal', category: 'Payment', open: action.open, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, OPEN_QUICK_SIGNUP, function (action, getState) {
  return { name: 'Popup Quick Sign Up', category: 'Payment', open: action.open, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, OPEN_LOGIN_SIGNUP, function (action, getState) {
  return { name: 'Open Login', category: 'Payment', step: getState().payment.step, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, LOGGED_IN, function (action, getState) {
  return { name: 'Logged In', category: 'Payment', step: getState().payment.step, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, CLICK_APPLY_PROMO, function (action, getState) {
  return { name: 'Click Apply Promo', category: 'Payment', code: action.code, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, APPLY_PROMO_SUCCESS, function (action, getState) {
  return { name: 'Apply Promo', category: 'Payment', code: action.code, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, LOG_ACCEPT_SWAP, function (action, getState) {
  return { name: 'Accept Swap', category: 'Payment', checked: action.checked, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, LOG_SET_DATE, function (action, getState) {
  return { name: 'Set Date', category: 'Payment', date: action.date, dateStatus: action.dateStatus, requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, LOG_BOOKING_ERROR, function (action) {
  var err = JSON.parse((0, _stringify2.default)(action.error, (0, _getOwnPropertyNames2.default)(action.error)));
  return { name: 'Payment fail - Omise (Front-End)', category: 'Payment', error: err };
}), (0, _defineProperty3.default)(_analytics, GO_TO_STEP2, function (action, getState) {
  return {
    name: 'Go To Step 2nd',
    category: 'Payment',
    requestId: getState().payment.requestId,
    tripId: getState().payment.trip._id,
    tripDate: getState().payment.date,
    quantity: getState().payment.quantity,
    meetingPoint: getState().payment.meetingPoint
  };
}), (0, _defineProperty3.default)(_analytics, GO_TO_STEP3, function (action, getState) {
  return {
    name: 'Go To Step 3rd',
    category: 'Payment',
    code: getState().payment.promo,
    firstName: getState().payment.firstName,
    lastName: getState().payment.lastName,
    email: getState().payment.email,
    lastMobile: getState().payment.lastMobile,
    lastCountry: getState().payment.lastCountry,
    selectedCard: getState().payment.selectedCard,
    requestId: getState().payment.requestId
  };
}), (0, _defineProperty3.default)(_analytics, GO_TO_STEP4, function (action, getState) {
  return { name: 'Go To Step 4th', category: 'Payment', requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, GO_TO_MESSAGE, function (action, getState) {
  return { name: 'Go To Message', category: 'Payment', requestId: getState().payment.requestId };
}), (0, _defineProperty3.default)(_analytics, LOG_REQUEST, function (action) {
  return (0, _extends5.default)({}, action.data, { name: 'Log Request', category: 'Payment' });
}), (0, _defineProperty3.default)(_analytics, LOG_SELECT_PAYMENT_METHOD, function (action) {
  return { name: 'Change Payment method', category: 'Payment', providers: 'database', data: action.method };
}), (0, _defineProperty3.default)(_analytics, LOG_PAYPAL_FAIL, function (action) {
  return { name: 'Payment fail - PayPal (Front-End)', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_CONTINUE_WITHOUT_PROMO, function (action) {
  return { name: 'Continue without Promo', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_PAY_BY_AFTERPAY, function (action) {
  return { name: 'Pay by Afterpay', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_CREDIT_AFTER_AFTERPAY, function (action) {
  return { name: 'Select credit card after tried Afterpay', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_PAYPAL_AFTER_AFTERPAY, function (action) {
  return { name: 'Select PayPal after tried Afterpay', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_ON_SEEN_INSURANCE_FORM, function (action) {
  return { name: 'Seen insurance form', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_SUBMIT_INSURANCE_FIRST_STEP, function (action) {
  return { name: 'Submit insurance form first step', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_SUBMIT_INSURANCE_LAST_STEP, function (action) {
  return { name: 'Submit insurance form last step', category: 'Payment', providers: 'database', data: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_CANCEL_INSURANCE, function (action) {
  return { name: 'Cancel insurance form', category: 'Payment', providers: 'database', data: action.data };
}), _analytics);

function requestBooking(type, device) {
  var tripId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var tripDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var quantity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var promo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var multi_tier_quantity = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var selected_options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  // eslint-disable-line
  if (window.hj) {
    window.hj('tagRecording', ['booking']);
  }
  // console.log('request:', selected_options);
  return {
    types: [REQUEST_BOOKING, REQUEST_BOOKING_SUCCESS, REQUEST_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/request', { data: {
          type: type,
          trip_id: tripId,
          trip_date: tripDate,
          quantity: quantity,
          promo: promo,
          multi_tier_quantity: multi_tier_quantity,
          selected_options: selected_options
        } });
    },
    requestType: type,
    device: device
  };
}
function trigger(id, email, mobile, firstName, lastName) {
  var tripId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var tripDate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var quantity = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var paymentRequestEnabled = arguments[8];

  return {
    types: [TRIGGER, TRIGGER_SUCCESS, TRIGGER_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/trigger', { data: {
          id: id,
          email: email,
          mobile: mobile,
          quantity: quantity,
          first_name: firstName,
          last_name: lastName,
          trip_id: tripId,
          trip_date: tripDate,
          type: 'book',
          paymentRequestEnabled: paymentRequestEnabled
        } });
    }
  };
}
// export function viewPaymentPage(id, step) {
//   console.log('VIEW PAGE', id, step);
//   return {
//     type: VIEW_PAYMENT_PAGE,
//     id,
//     step,
//   };
// }

function clearCreditCard() {
  return {
    type: CLEAR_CREDIT_CARD
  };
}

function setViewedStep(viewedStep) {
  return {
    type: SET_VIEWED_STEP,
    viewedStep: viewedStep
  };
}
function clickSendMessage() {
  return {
    type: CLICK_SEND_MESSAGE
  };
}
function clickApplyPromo(code) {
  return {
    type: CLICK_APPLY_PROMO,
    code: code
  };
}
function openPaypal() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  // deprecated
  return {
    type: OPEN_PAYPAL,
    open: open
  };
}
function openQuickSignup() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_QUICK_SIGNUP,
    open: open
  };
}
function paymentOpenLoginSignup() {
  return {
    type: OPEN_LOGIN_SIGNUP
  };
}
function paymentLoggedIn() {
  return {
    type: LOGGED_IN
  };
}
function goToStep2() {
  return {
    type: GO_TO_STEP2
  };
}
function goToStep3() {
  return {
    type: GO_TO_STEP3
  };
}
function goToStep4() {
  return {
    type: GO_TO_STEP4
  };
}
function goToMessage() {
  return {
    type: GO_TO_MESSAGE
  };
}
function setExtraField(name, value) {
  return {
    type: SET_EXTRA_FIELD,
    name: name, value: value
  };
}
function processExtraPayment(data) {
  return {
    types: [PROCESS_EXTRA_PAYMENT, PROCESS_EXTRA_PAYMENT_SUCCESS, PROCESS_EXTRA_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/extraCharge', { data: data });
    }
  };
}
function logAcceptSwap(checked) {
  return {
    type: LOG_ACCEPT_SWAP,
    checked: checked
  };
}
function logSetDate(date, dateStatus) {
  return {
    type: LOG_SET_DATE,
    date: date,
    dateStatus: dateStatus
  };
}
function logBookingError(error) {
  return {
    type: LOG_BOOKING_ERROR,
    error: error
  };
}

function enablePaymentRequest() {
  return {
    type: ENABLE_PAYMENT_REQUEST
  };
}

function disablePaymentRequest() {
  return {
    type: DISABLE_PAYMENT_REQUEST
  };
}

function logRequest(data) {
  return {
    type: LOG_REQUEST,
    data: data
  };
}

function editEmail(id, email) {
  return {
    types: [EDIT_EMAIL, EDIT_EMAIL_SUCCESS, EDIT_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/edit-email', { data: { email: email } });
    }
  };
}

function logChangePaymentMethod(method) {
  return {
    type: LOG_SELECT_PAYMENT_METHOD,
    method: method
  };
}

function logPaypalFail() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: LOG_PAYPAL_FAIL,
    data: {
      error: error
    }
  };
}

function logContinueWithoutPromo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: LOG_CONTINUE_WITHOUT_PROMO,
    data: data
  };
}

// export function logPayInCash(data = {}) {
//   return {
//     type: LOG_PAY_IN_CASH,
//     data
//   };
// }

// export function logCreditAfterCash(data = {}) {
//   return {
//     type: LOG_CREDIT_AFTER_CASH,
//     data
//   };
// }

// export function logPayPalAfterCash(data = {}) {
//   return {
//     type: LOG_PAYPAL_AFTER_CASH,
//     data
//   };
// }

function logPayByAfterpay() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: LOG_PAY_BY_AFTERPAY,
    data: data
  };
}

function logCreditAfterAfterpay() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: LOG_CREDIT_AFTER_AFTERPAY,
    data: data
  };
}

function logPayPalAfterAfterpay() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: LOG_PAYPAL_AFTER_AFTERPAY,
    data: data
  };
}

function checkExistingBooking(data) {
  return {
    types: [CHECK_EXISTING_BOOKING, CHECK_EXISTING_BOOKING_SUCCESS, CHECK_EXISTING_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/existing-booking', { data: data });
    }
  };
}

function shouldShowWarningPopup() {
  var productScopes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['trip'];
  var tripDate = arguments[1];

  return {
    types: [SHOULD_SHOW_WARNING_POPUP, SHOULD_SHOW_WARNING_POPUP_SUCCESS, SHOULD_SHOW_WARNING_POPUP_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/check-confirmed-booking', { data: { productScopes: productScopes, tripDate: tripDate } });
    }
  };
}

function closeWarningPopup() {
  return {
    type: CLOSE_WARNING_POPUP
  };
}

function submitInsurances(id, data) {
  return {
    types: [SUBMIT_INSURANCES, SUBMIT_INSURANCES_SUCCESS, SUBMIT_INSURANCES_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/insurance', { data: data });
    }
  };
}

function logOnSeenInsuranceForm(isGuest, bookingId) {
  return {
    type: LOG_ON_SEEN_INSURANCE_FORM,
    data: { isGuest: isGuest, bookingId: bookingId }
  };
}

function logSubmitInsuranceFirstStep(isGuest, bookingId) {
  return {
    type: LOG_SUBMIT_INSURANCE_FIRST_STEP,
    data: { isGuest: isGuest, bookingId: bookingId }
  };
}

function logSubmitInsuranceLastStep(bookingId) {
  return {
    type: LOG_SUBMIT_INSURANCE_LAST_STEP,
    data: { bookingId: bookingId }
  };
}

function logCancelInsurance(isGuest, bookingId) {
  return {
    type: LOG_CANCEL_INSURANCE,
    data: { isGuest: isGuest, bookingId: bookingId }
  };
}

// export function changeTier(activeTier) {
//   return {
//     type: CHANGE_TIER,
//     activeTier,
//   };
// }


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/payment.js
// module id = 46
// module chunks = 47